/* Task #151: simplify the "Don't see your size?" size-request UI copy.
   sections/main-product.liquid is too large to safely rewrite wholesale (see other
   pdp-*.js patch files in this theme for the established convention), so this small,
   additive, idempotent script trims the trailing "Let us know" off the modal heading
   and the trigger button's aria-label at runtime instead of editing that section file. */
(function(){
  function simplify(){
    document.querySelectorAll('[data-size-request-chip]').forEach(function(btn){
      var label = btn.getAttribute('aria-label');
      if(label && /let us know/i.test(label)){
        btn.setAttribute('aria-label', "Don't see your size?");
      }
    });
    document.querySelectorAll('[data-sizereq-wrap] h3').forEach(function(h){
      if(/let us know/i.test(h.textContent)){
        h.textContent = "Don't see your size?";
      }
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', simplify);
  } else {
    simplify();
  }
})();
